var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status)?_c('div',{staticClass:"loader"},[_c('span',{staticClass:"loader__icon",style:(("borderColor: " + _vm.selectColorLoader + " transparent " + _vm.selectColorLoader + " " + _vm.selectColorLoader))})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }